module.exports = __webpack_public_path__ + "static/media/Sunny soffa 3-sits XL tyg orinocco grey miljö 2023.00abd759.jpg";